// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- We're extending Angular's native FormArray here.
import {FormArray} from '@angular/forms';
import {AngularAsyncValidator, ExtendedAbstractControl} from '@aviary/forms/extensions/form-extensions.types';
import {AsyncValidatorRemoverResult, removeAsyncValidatorsFrom} from '@aviary/forms/extensions/form-extensions.helpers';

export class ExtendedFormArray<T extends ExtendedAbstractControl = ExtendedAbstractControl> extends FormArray<T> implements ExtendedAbstractControl {

  public shouldRender: boolean = true;
  public readonly uuid: string = crypto.randomUUID();
  public readonly initialUuids: string[];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Angular's validatorOrOpts arguments are typed as any, so we maintain that type.
  constructor(controls: T[] = [], validatorOrOpts?: any, asyncValidator?: AngularAsyncValidator) {
    const {validatorOrOptsWithoutAsyncValidators, addRemovedAsyncValidatorsTo}: AsyncValidatorRemoverResult =
      removeAsyncValidatorsFrom(validatorOrOpts, asyncValidator);

    super(controls, validatorOrOptsWithoutAsyncValidators);

    this.initialUuids = controls.map(control => control.uuid);

    addRemovedAsyncValidatorsTo(this);
  }

  public get extendedControls(): T[] {
    // eslint-disable-next-line no-restricted-syntax -- We're using this.controls to create this extended getter that replaces it.
    return this.controls as T[];
  }

  public override insert(index: number, control: T): void {
    super.insert(index, control);

    // Let hasChanged() get past its pristine check for this array and its parent.
    this.markAsDirty();
    this.parent?.markAsDirty();
  }

  public override removeAt(index: number): void {
    super.removeAt(index);

    // Let hasChanged() get past its pristine check for this array and its parent.
    this.markAsDirty();
    this.parent?.markAsDirty();
  }

  public override clear(): void {
    if (this.length === 0) return;

    // Remove from the end so indices don't shift.  Remove silently and bypass our own removeAt() override so that we don't call markAsDirty() every time.
    for (let i = this.length - 1; i >= 0; i--) {
      super.removeAt(i, {emitEvent: false});
    }
  }
}
